<template>
    <div>
        <ul>
            <template v-if="currentPlan.virtualPlan===false && !hasValue(currentPlan.openTemplate)">
                <li>
               <span :class="highlighterClass('visitFee')">
                   Visit Fee:
                   <span>
                       {{(planValues.visitFee || 0) | currency}}
                   </span>
               </span>
                </li>
                <li>
               <span :class="highlighterClass('urgentCareFee')">
                   Urgent Care Fee:
                   <span>
                       {{(planValues.urgentCareFee || 0) | currency}}
                   </span>
               </span>
                </li>
                <li>
               <span :class="highlighterClass('preventativeCareDesc')">
                   Preventative Care:
                   <span :class="highlighterClass('preventativeCareDesc')">
                       {{planValues.preventativeCareDesc}}
                   </span>
               </span>
                </li>
                <li>
               <span :class="highlighterClass('afterHoursDesc')">
                   After Hours:
                   <span :class="highlighterClass('afterHoursDesc')">
                       {{planValues.afterHoursDesc}}
                   </span>
               </span>
                </li>
            </template>
            <template v-if="currentPlan.openTemplate">
                <div class="open-plan-template-setting" v-html="currentPlan.openTemplate" :class="highlighterClass('openTemplate')">

                </div>
            </template>
            <template v-else-if="currentPlan.virtualPlan===false">
                <template v-for="(value,key) in planValues">
                    <template v-if="displayProperty(key)">
                        <li>
                            <template v-if="isBoolean(key)">
                            <span v-if="value" style="color:green">
                                    <span class="fa fa-check"></span>
                            </span>
                                <span v-else style="color:red">
                                <span class="fa fa-times"></span>
                            </span>
                                <span :class="highlighterClass(key)">{{booleanMapper[key]}}</span>
                            </template>
                            <!--<template v-else>-->
                            <!--<span :class="highlighterClass(key)">-->
                            <!--{{nonBooleanMapper[key]}} : {{value || 'N/A'}}-->
                            <!--</span>-->
                            <!--</template>-->
                        </li>
                    </template>
                </template>
            </template>

        </ul>
    </div>
</template>

<script>
    import {booleanPlanPropertiesMapper} from "./booleamPropertiesMapper.js";
    import {nonBooleanMapper} from "./NonBooleanMapper.js";

    export default {
        name: "PlanSettings",
        props: {
            currentPlan: {type: [Object], required: true},
            futurePlan: {type: [Object], required: false, default: null}
        },
        data() {
            return {
                booleanMapper: {...booleanPlanPropertiesMapper, chargesVisitFee: "Charges Visit Fee"},
                nonBooleanMapper: nonBooleanMapper
            }
        },
        computed: {
            hasPendingChange() {
                return Boolean(this.futurePlan) && Boolean(this.futurePlan.planId);
            },
            planValues() {
                return this.hasPendingChange ? this.futurePlan : this.currentPlan;
            }
        },
        methods: {
            displayProperty(propertyName) {
                return booleanPlanPropertiesMapper.hasOwnProperty(propertyName);// || nonBooleanMapper.hasOwnProperty(propertyName);
            },
            isBoolean(propertyName) {
                return booleanPlanPropertiesMapper.hasOwnProperty(propertyName);
            },
            highlighterClass(propertyName) {
                return this.hasPendingChange && (this.currentPlan[propertyName] != this.futurePlan[propertyName]) ? 'highlight' : '';
            },
        }
    }
</script>

<style scoped>
    .highlight {
        background-color: yellow;
    }
</style>